import React from 'react';
import RepVisitsUnlockPremiumView from '../RepVisitsUnlockPremiumView';
import travelplanUnlockMessages from './travelplan-unlock-messages';
import PageTitle from '../../components/PageTitle';

const unlockPremiumProps = {
  activeStyle: 'travelplan',
  messages: travelplanUnlockMessages,
};

const RepVisitsTravelPlanUnlockPage = () => (
  <div>
    <PageTitle title="RepVisits" category="Intersect" />
    <RepVisitsUnlockPremiumView {...unlockPremiumProps} />
  </div>
);

export default RepVisitsTravelPlanUnlockPage;
